/**
 * Created by neo on 28.05.17.
 */

import {observable} from 'mobx';

export default class TimeRange {
  @observable start: string;
  @observable end: string;

  constructor(json?: string) {
    if(json) {
      this.start = json.start;
      this.end = json.end;
      this.meeting_time = json.meeting_time;
      this.dropoff_time = json.dropoff_time;
    }
  }
};



// WEBPACK FOOTER //
// ./src/App/Store/TimeRange.js